<template>

  <svg
    t="1639131563580"
    class="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="4137"
    width="64"
    height="64"
  ><path d="M250.52 209.31999969A398.44000031 398.44000031 0 0 1 512 111.99999969c220.92 0 400.00000031 179.08000031 400.00000031 400.00000031 0 85.44-26.80000031 164.64-72.40000031 229.60000031L711.99999969 512h120A319.99999969 319.99999969 0 0 0 290.40000031 281.12l-39.88000031-71.80000031z m522.96 605.36000062A398.44000031 398.44000031 0 0 1 512 912.00000031C291.08 912.00000031 111.99999969 732.92 111.99999969 512c0-85.44 26.80000031-164.64 72.40000031-229.60000031L312.00000031 512H192.00000031a319.99999969 319.99999969 0 0 0 541.59999938 230.88l39.88000031 71.80000031z" p-id="4138" /></svg>


</template>

<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'JtIconRefresh',
} as DefineComponent
</script>